//#region redux
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";
import { LocalizationHelperInstance } from "utils/helpers";
import { externalCompanyHoldingsSnoozed } from "store/actions/externalCompanyHoldingsActions";

function useExternalCompanyHoldingsSnoozeAction(id: number | string, onActionSuccess: (id: number | string) => void) {
  const dispatch = useDispatch();

  const onSnoozeExternalCompanyHoldingsSuccess = () => {
    dispatch(externalCompanyHoldingsSnoozed(id));
    onActionSuccess(id);
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.ExternalCompanyHoldings,
    onSnoozeExternalCompanyHoldingsSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.ExternalCompanyHoldings.ExternalCompanyHoldings)
  );

  return snoozeAction;
}

export default useExternalCompanyHoldingsSnoozeAction;
